<template>
  <div class="container">
    <div style="width: 35%; height:60%;padding: 1%; border-radius: 1%;margin-right: 2.2%;margin-top:1%;margin-bottom: 7%">
      <div style="margin-top: 2%;text-align: center; font-size: 30px; color: #fbc200;" >零协会公告系统</div>
      <div style="margin-top: 20%; padding: 10%; font-size: 30px;width: 100%; height:100%;">
        <el-form :model="form" :rules="rules" ref="formRef" style="font-size: 30px;" >
          <el-form-item prop="username" >
            <el-input prefix-icon="el-icon-user" placeholder="请输入账号" v-model="form.username" class="login_css"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input prefix-icon="el-icon-lock" placeholder="请输入密码" show-password  v-model="form.password" class="login_css"></el-input>
          </el-form-item>
          <el-form-item style="text-align: center;"class="login_css">
            <el-switch
                style="display: block"
                v-model="form.role"
                active-color="#fbc200"
                inactive-color="#ff4949"
                color="white"
                active-text="用户"
                inactive-text="管理员"
                active-value="USER"
                inactive-value="ADMIN">
            </el-switch>

          </el-form-item>
          <el-form-item>
            <el-button round style="width: 100%; background-color: #fbc200; border-color: #333; color: white" @click="login" class="login_css">登 录</el-button>
          </el-form-item>

        </el-form>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "Login",
  data() {
    return {
      form: {
        role:"USER"
      },
      rules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ]
      }
    }
  },
  created() {

  },
  methods: {
    login() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          const formData = JSON.parse(JSON.stringify(this.form));

          this.$request.post('/login', this.form).then(res => {

            if (res.code === '200') {
              // Handle successful response
              localStorage.setItem("xm-user", JSON.stringify(res.data));
              this.$router.push({ name: 'Loading' });
              setTimeout(() => {
                this.$router.push('/');
                this.$message.success('登录成功');
              }, 2000);
            } else {
              // Handle error response
              this.$message.error(res.msg);
            }
          }).catch(error => {
            this.$message.error('请求出错，请稍后重试');
          });
        }
      });
    }
  }
}
</script>

<style scoped>
.container {
  height: 100vh;
  overflow: hidden;
  background-image: url("@/assets/imgs/login_form.png");
  background-size: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fbc200;
}
a {
  color: white;
}
.login_css{
  font-size: 20px;
  line-height: 30px;
}
</style>
<style>

.el-switch__label {
  width: 50px !important;
  height: 30px;
  font-size: 20px;
  color: white;
}

</style>